<div class="detail" [loading]="loading">
  <div *ngIf="!loading">
    <div style="display:flex">
      <div class="line-height-l" style="min-width: 120px;">
        <a uiSref="^" class="button mb-10"><i class="fa fa-chevron-left mr-5"></i>seznam vlastníků</a>
      </div>
      <div class="actions">
        <a uiSref="symap.project.map" [uiParams]="{ subject: ownerId }" class="button"><i class="fa fa-map-marker"></i>Zobrazit v mapovém okně</a>

        <a uiSref="symap.project.owners.detail.problematic" [uiParams]="{'tab': tab, 'ownerId': ownerId}" class="button">problematický vlastník</a>
      </div>
    </div>

    <h1>{{owner | subjectName}}</h1>
    <span class="tag tag--danger tag--not-clickable is-uppercase mt-5 mr-10" *ngIf="owner.subjectDetail?.problematic">Problematický vlastník</span>
    <span class="tag tag--inactive tag--not-clickable is-uppercase mt-5 mr-10" *ngIf="owner.endDate">Bývalý vlastník</span>

    <sanction-tags [detail]="owner.subjectDetail"></sanction-tags>

    <div class="row mt-30">
      <div class="col-md-12 col-lg-6 col-xl-4" style="min-height: 110px; position: relative;">
        <div style="height: 100%;position: relative;">
          <perfect-scrollbar [wheelPropagation]="true" style="height: 100%;width: 100%;position: absolute;">
            <titles-short-list
              [ownershipList]="ownershipList"
              [options]="{showOwnerships: true}"
            ></titles-short-list>
          </perfect-scrollbar>
        </div>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-8">
        <div class="column-100">
          <label>Adresa</label>
          <div class="info">
            {{ owner.subjectDetail?.customAddressUse ? (owner.subjectDetail | address) : (owner | address) }}
          </div>

          <ng-container *ngIf="owner.opsubType === 'OFO'; else legalPerson">
            <label>Rodné číslo</label>
            <div class="info">{{owner.subjectDetail?.personalIdentificationNumber || owner.rodneCislo }}</div>

            <label>Datum narození</label>
            <div class="info">{{owner.subjectDetail?.dateOfBirth | date }}</div>
          </ng-container>

          <ng-template #legalPerson>
            <label>IČO</label>
            <div class="info">{{ owner.ico }}</div>
          </ng-template>

          <label>Telefon</label>
          <div class="info">
            {{ ownerContact.phoneNumber }}
          </div>
          <label>E-mail</label>
          <div class="info">
            {{ ownerContact.email }}
          </div>
          <label>Datová schránka</label>
          <div class="info">
            {{ ownerContact.databoxId }}
          </div>
        </div>
      </div>
    </div>

    <div class="mt-80">
      <gmt-navbar [tabs]="tabs" [isActiveTab]="isActiveTab">
        <tab-owner-about [owner]="owner" *ngIf="tab === 'about'"></tab-owner-about>
        <tab-owner-representation [representatives]="owner.actingPersons" *ngIf="tab === 'representation'"></tab-owner-representation>
        <div *ngIf="tab === 'parcels'">
          <div [loading]="easementList.loading || occupationList.loading">
            <gmt-labeled-block *ngIf="occupationGroups?.permanent" [collapsed]="false" label="{{ 'PERMANENT_OCCUPATION' | wordtranslate }}">
              <table-occupations-permanent [data]="occupationGroups.permanent" [columns]="occupationPermanentColumns"></table-occupations-permanent>
            </gmt-labeled-block>
            <div *ngIf="!occupationList.loading && occupationGroups?.permanentWithSolutionType">
              <gmt-labeled-block label="Trvalý zábor bez výkupu (nájem)">
                <table-occupations-temporary [data]="occupationGroups.permanentWithSolutionType" [columns]="permanentWithSolutionTypeColumns"></table-occupations-temporary>
              </gmt-labeled-block>
            </div>
            <gmt-labeled-block *ngIf="occupationGroups?.underOneYear" [collapsed]="false" [label]="occupationUnderYearTableName">
              <table-occupations-temporary [data]="occupationGroups.underOneYear" [columns]="occupationUnderOneYearColumns"></table-occupations-temporary>
            </gmt-labeled-block>
            <gmt-labeled-block *ngIf="occupationGroups?.overOneYear" [collapsed]="false" [label]="occupationOverYearTableName">
              <table-occupations-temporary [data]="occupationGroups.overOneYear" [columns]="occupationOverOneYearColumns"></table-occupations-temporary>
            </gmt-labeled-block>
            <gmt-labeled-block *ngIf="easementList.list && easementList.list.length > 0" [collapsed]="false" label="{{ 'EASEMENT' | wordtranslate }}">
              <table-easements [data]="easementList.list" [columns]="easementColumns"></table-easements>
            </gmt-labeled-block>
          </div>
        </div>
        <div *ngIf="tab === 'otherParcels'">
          <gmt-labeled-block label="Ostatní parcely v zájmovém území">
            <div class="bordered" [loading]="parcelsOtherLoading">
              <div *ngIf="!parcelsOtherLoading">
                <div *ngIf="!dataParcelsOther.length && !parcelsOtherLoading" class="empty-info">Žádné parcely</div>
                <table *ngIf="dataParcelsOther.length">
                  <thead>
                  <tr>
                    <th>Parcela</th>
                    <th>Případ</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let parcel of dataParcelsOther">
                    <td class="no-padding cell-max-height">
                      <cell-parcel
                        [parcel]="parcel"
                        [tooltipType]="'parcel'"
                        [tooltipData]="{ parcel: parcel, withoutTitle: false }"
                        [showProtection]="true"
                      ></cell-parcel>
                    </td>
                    <td class="no-padding cell-max-height">
                      <cell-cases
                        [casesCount]="parcel.countCases"
                        [tooltipType]="'cases'"
                        [tooltipData]="{ filter: { filters: { parcelId: parcel.id, cancelStatus: 'notCancelled' }}}"
                      ></cell-cases>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </gmt-labeled-block>
        </div>

        <div *ngIf="tab === 'buildings'">
          <gmt-labeled-block label="Budovy">
            <div class="bordered" [loading]="buildingsLoading">
              <div *ngIf="!buildingsLoading && dataBuildings.length === 0" class="empty-info">Žádné budovy</div>
              <table *ngIf="!buildingsLoading && dataBuildings.length !== 0">
                <thead>
                <tr>
                  <th>Parcela</th>
                  <th>LV parcely</th>
                  <th>LV budovy</th>
                  <th>Část obce</th>
                  <th>Číslo budovy</th>
                  <th>Typ a Využití</th>
                  <th>Ochrana</th>
                  <!-- radit? -->
                  <th>Případy</th>
                  <th>Cena [<span class="unit">Kč</span>]</th>
                </tr>
                </thead>
                <tbody *ngFor="let itemBuilding of dataBuildings" class="hover">
                <tr *ngFor="let itemParcel of itemBuilding.parcels; let index = index">
                  <td class="no-padding">
                    <div class="fill-content">
                      <div class="pt-10 pl-10" *ngIf="itemParcel.soucasti">
                        součástí
                      </div>
                      <cell-parcel
                        [parcel]="itemParcel"
                        [tooltipType]="'parcel'"
                        [tooltipData]="{ parcel: itemParcel }"
                        showTitle="true"
                      ></cell-parcel>
                    </div>
                  </td>
                  <td class="number">
                    <span *ngIf="!itemParcel.title">{{ itemParcel.lv }}</span>
                    <a *ngIf="itemParcel.title" uiSref="symap.project.titles.detail" [uiParams]="{ id: itemParcel.title.id, tab: null }">{{ itemParcel.title.lv }}</a>
                  </td>
                  <td *ngIf="index === 0" [attr.rowspan]="itemBuilding.parcels.length" class="number">
                    <span *ngIf="!itemBuilding.title">{{ itemBuilding.cisloTel }}</span>
                    <a *ngIf="itemBuilding.title" uiSref="symap.project.titles.detail" [uiParams]="{ id: itemBuilding.title.id, tab: null }">{{ itemBuilding.title.lv }}</a>
                  </td>
                  <td *ngIf="index === 0" [attr.rowspan]="itemBuilding.parcels.length">{{ itemBuilding.castobce }}</td>
                  <td *ngIf="index === 0" [attr.rowspan]="itemBuilding.parcels.length">{{ itemBuilding | buildingNumber:true }}</td>
                  <td *ngIf="index === 0" [attr.rowspan]="itemBuilding.parcels.length">{{ itemBuilding.typ }}<br>{{ itemBuilding.vyuziti }}</td>
                  <td *ngIf="index === 0" [attr.rowspan]="itemBuilding.parcels.length">
                    <span class="comma-list">
                      <span *ngFor="let itemProtection of itemBuilding.buildingProtections">{{itemProtection.nazevOchrany}}</span>
                    </span>
                  </td>
                  <td *ngIf="index === 0" [attr.rowspan]="itemBuilding.parcels.length" class="no-padding cell-max-height">
                    <cell-cases
                      [casesCount]="itemBuilding.countCases"
                      [tooltipType]="'cases'"
                      [tooltipData]="{ filter: { filters: { buildingId: itemBuilding.id, cancelStatus: 'notCancelled' }}}"
                    ></cell-cases>
                  </td>
                  <td *ngIf="index === 0" [attr.rowspan]="itemBuilding.parcels.length">{{ itemBuilding.buildingsPrice | number | price : false }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </gmt-labeled-block>
        </div>

        <div *ngIf="tab === 'otherBuildings'">
          <gmt-labeled-block label="Ostatní budovy v zájmovém území">
            <div class="bordered" [loading]="buildingsOtherLoading">
              <div *ngIf="!buildingsOtherLoading && dataBuildingsOther.length === 0" class="empty-info">Žádné budovy</div>
              <table *ngIf="!buildingsOtherLoading && dataBuildingsOther.length !== 0">
                <thead>
                <tr>
                  <th>Parcela</th>
                  <th>LV parcely</th>
                  <th>LV budovy</th>
                  <th>Část obce</th>
                  <th>Číslo budovy</th>
                  <th>Typ a Využití</th>
                  <th>Ochrana</th>
                </tr>
                </thead>
                <tbody *ngFor="let itemBuilding of dataBuildingsOther" class="hover">
                <tr *ngFor="let itemParcel of itemBuilding.parcels; let index = index">
                  <td class="no-padding">
                    <div class="fill-content">
                      <div class="pt-10 pl-10" *ngIf="itemParcel.soucasti">
                        součástí
                      </div>
                      <cell-parcel
                        [parcel]="itemParcel"
                        [tooltipType]="'parcel'"
                        [tooltipData]="{ parcel: itemParcel }"
                      ></cell-parcel>
                    </div>
                  </td>
                  <td class="number">
                    <span *ngIf="!itemParcel.title">{{ itemParcel.lv }}</span>
                    <a *ngIf="itemParcel.title" uiSref="symap.project.titles.detail" [uiParams]="{ id: itemParcel.title.id, tab: null }">{{ itemParcel.title.lv }}</a>
                  </td>
                  <td *ngIf="index === 0" [attr.rowspan]="itemBuilding.parcels.length" class="number">
                    <span *ngIf="!itemBuilding.title">{{ itemBuilding.cisloTel }}</span>
                    <a *ngIf="itemBuilding.title" uiSref="symap.project.titles.detail" [uiParams]="{ id: itemBuilding.title.id, tab: null }">{{ itemBuilding.title.lv }}</a>
                  </td>
                  <td *ngIf="index === 0" [attr.rowspan]="itemBuilding.parcels.length">{{ itemBuilding.castobce }}</td>
                  <td *ngIf="index === 0" [attr.rowspan]="itemBuilding.parcels.length">{{ itemBuilding | buildingNumber:true }}</td>
                  <td *ngIf="index === 0" [attr.rowspan]="itemBuilding.parcels.length">{{ itemBuilding.typ }}<br>{{ itemBuilding.vyuziti }}</td>
                  <td *ngIf="index === 0" [attr.rowspan]="itemBuilding.parcels.length">
                    <span class="comma-list">
                      <span *ngFor="let itemProtection of itemBuilding.buildingProtections">{{itemProtection.nazevOchrany}}</span>
                    </span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </gmt-labeled-block>
        </div>

        <div *ngIf="tab === 'cases'">
          <table-cases
            [loading]="caseList.loading"
            [list]="caseList"
            (sort)="onCaseTableSort($event)"
          ></table-cases>
        </div>
        <div *ngIf="tab === 'notes'">
          <gmt-notes
            [noteList]="noteList"
            [editable]="true"
            [allowType]="true"
            [defaultData]="{subject: {id: owner.id}, systemType: false}"
            (updated)="onUpdateNoteList()"
          ></gmt-notes>
        </div>
        <div *ngIf="tab === 'notifications'">
          <gmt-notifications
            [notificationList]="notificationList"
            (updated)="onUpdateNotificationList();loadHistory();"
          ></gmt-notifications>
        </div>
        <div *ngIf="tab === 'documents'">
          <gmt-attachments
            [attachmentList]="attachmentList"
            [defaultData]="{opsubId: owner.opsubId}"
            [authorizedUser]="canEdit()"
            [allowType]="true"
            attachmentCategory="subject"
            (updated)="onUpdateAttachmentList();loadHistory();"
          ></gmt-attachments>
        </div>
        <div *ngIf="tab === 'documents-epd'">

          <gmt-navbar [tabs]="documentTabs" [isActiveTab]="isActiveDocumentTab" (changed)="documentTab = $event">
            <div *ngIf="documentTab === 'documents-epd__documents'">
              <gmt-documents
                *ngIf="documentList && documentList.list"
                [documentList]="documentList"
                [uploadDestination]="{ entityType: 'subject', id: owner.id }"
                (updated)="loadDocuments(); loadHistory();"
              ></gmt-documents>
            </div>
            <div *ngIf="documentTab === 'documents-epd__components'">
              <gmt-components
                *ngIf="documentList && documentList.list"
                [documentList]="documentList"
                (updated)="loadDocuments(); loadHistory();"
              ></gmt-components>
            </div>
          </gmt-navbar>
        </div>
        <div *ngIf="tab === 'history'">
          <gmt-notes
            [type]="'history'"
            [noteList]="historyList"
            [editable]="false"
            [allowType]="true"
          ></gmt-notes>
        </div>
      </gmt-navbar>
    </div>
  </div>
  <help [helpId]="helpIds.PS_SUBJECT_DETAIL" class="cm-help-page"></help>
</div>
